import { render, staticRenderFns } from "./details_encours.vue?vue&type=template&id=27ea967e"
import script from "./details_encours.vue?vue&type=script&lang=js"
export * from "./details_encours.vue?vue&type=script&lang=js"
import style0 from "./details_encours.vue?vue&type=style&index=0&id=27ea967e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports